<template>
  <div
    v-click-outside="hide"
    class="dropdown"
    :class="{'dropdown--active': isActive, 'dropdown--right': isRight, 'dropdown--light': isLight}"
  >
    <button
      class="dropdown__toggle"
      @click="toggle"
    >
      <slot />
      <span
        v-if="count"
        class="dropdown__number"
      >{{ count }}</span>
      <v-icon
        v-if="hasChevron"
        class="dropdown__chevron"
        type="angle-down"
      />
    </button>
    <v-dropdown-menu
      class="dropdown__menu"
      :has-gradient="hasGradient"
      :is-collapsible="isCollapsible"
      :is-active="isActive"
    >
      <slot name="dropdown-menu" />
    </v-dropdown-menu>
  </div>
</template>

<script>
  import ClickOutside from 'vue-click-outside'
  import Icon from '@/atoms/Icon';
  import DropdownMenu from '@/atoms/DropdownMenu';

  export default {
    components: {
      "v-icon": Icon,
      "v-dropdown-menu": DropdownMenu
    },
    directives: {
      ClickOutside
    },
    props: {
      isRight: {
        type: Boolean,
        default: false
      },
      isLight: {
        type: Boolean,
        default: false
      },
      isCollapsible: {
        type: Boolean,
        default: false
      },
      hasGradient: {
        type: Boolean,
        default: false
      },
      hasChevron: {
        type: Boolean,
        default: false
      },
      count: {
        type: Number,
        default: null
      }
    },
    data: function () {
      return {
        isActive: false
      }
    },
    methods: {
      toggle: function () {
        this.isActive = !this.isActive;
      },
      hide: function () {
        this.isActive = false;
      }
    }
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";

  .dropdown {
    $this: &;
    position: relative;
    &__toggle {
      display: flex;
      align-items: center;
      background-color: transparent;
      border: none;
      color: $primary;
      cursor: pointer;
      font-weight: bold;
      transition: all .15s ease;
      font-size: $font-size-lg;
      &,
      &:focus {
        outline: none;
      }
    }
    &__chevron {
      display: block;
      margin-left: auto;
      padding-left: .5rem;
      padding-right: .5rem;
      transition: transform .15s ease;
    }
    &__number {
      position: absolute;
      top: .5rem;
      right: .5rem;
      display: block;
      height: 1rem;
      width: 1rem;
      border-radius: 50%;
      background-color: $tangerine;
      text-align: center;
      font-weight: 400;
      line-height: 1rem;
      font-size: .75rem;
    }
    &--right &__menu {
      left: auto;
      right: 0;
      &:after {
        left: auto;
        right: 8px;
        border-bottom-color: #001744;
      }
    }
    &--light {
      #{$this}__toggle {
        color: $white;
      }
      &#{$this}--active #{$this}__toggle {
        color: rgba($white, .5);
      }
    }
    &--active &__chevron {
      transform: rotate(-180deg);
    }
  }
</style>
